import { SchemaTypes } from '@allesauto/graphql';
import { Background } from '@allesauto/utils/consts';
import clsx from 'clsx';
import React, { FC } from 'react';

import ArrowBox, { ArrowBoxProps } from '../arrowBox';
import ServiceTile from '../serviceTile';

export interface ServiceCategorySectionProps {
  categoryBox: ArrowBoxProps;
  tiles: SchemaTypes.WorkshopServiceCategory['services'];
  background: Background;
  onClickHandler: (
    id: string,
    description: string,
    title: string,
    abstractProductSku: string
  ) => void;
}

const ServiceCategorySection: FC<ServiceCategorySectionProps> = (
  props: ServiceCategorySectionProps
) => {
  const { categoryBox, tiles, background, onClickHandler } = props;
  const className = {
    content: clsx(
      'flex sm:flex-col md:flex-row',
      background === Background.WHITE ? 'bg-grey10' : 'bg-white'
    ),
    category: 'flex sm:flex-row md:w-[360px]',
    tileSection:
      'sm:ml-15px sm:mr-15px md:ml-40px sm:mt-40px md:mt-80px flex flex-col',
    tileContent: 'flex md:flex-row sm:flex-col md:flex-wrap md:gap-40px',
    tileCard:
      'sm:mb-30px md:mb-40px flex sm:flex-row md:flex-col lg:w-[300px] w-full md:h-[432px]',
  };

  return (
    <div className={className.content}>
      <div className={className.category}>
        <ArrowBox
          currentBoxIndex={categoryBox.currentBoxIndex}
          categoryName={categoryBox.categoryName}
          title={categoryBox.title}
          offersNumber={categoryBox.offersNumber}
        />
      </div>
      <div className={className.tileSection}>
        <div className={className.tileContent}>
          {tiles &&
            tiles.map((tile, i) => (
              <div className={className.tileCard} key={i}>
                <ServiceTile
                  name={tile?.title || ''}
                  description={tile?.description || ''}
                  onClickHandler={() =>
                    onClickHandler(
                      tile?.sku || '',
                      tile?.description || '',
                      tile?.title || '',
                      tile?.abstractProductSku || ''
                    )
                  }
                  id={tile?.sku || ''}
                  abstractProductSku={tile?.abstractProductSku ?? ''}
                  background={background}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceCategorySection;
